export default __webpack_public_path__ + "static/media/fitgen.92f135e8.JPG";